// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___cI7Oj"};
    if(module.hot) {
      // 1729151128716
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  